<!-- 
  Making this as generic as possible till we have a better idea of the scenarios that we need to cover.

  Example Usage:
  <EmptyStateBasic
  title="nothing to show yet"
  subtitle="upload invoices and credit notes to get started"
>
  <ListIcon slot="illustration" />
  <svelte:fragment slot="cta">
    <Button size="small" --button-minH="0px" --button-padding="20px 13px">
      <TextNew size="s" weight="medium" --rk-text-color="var(--rk-text-light)">edit payment</TextNew
      >
    </Button>
    <Button size="small" --button-minH="0px" --button-padding="20px 13px">
      <TextNew size="s" weight="medium" --rk-text-color="var(--rk-text-light)">edit payment</TextNew
      >
    </Button>
  </svelte:fragment>
</EmptyStateBasic>
 -->
<script lang="ts">
  import TextNew from "../TextNew.svelte";
  export let title: string;
  export let subtitle: string;
  export let paddingBottom: boolean = true;
</script>

<div class="container" class:padding-bottom={paddingBottom}>
  <slot name="illustration" />
  <div class="msg">
    <TextNew as="h1" size="l" weight="medium">{title}</TextNew>
    <TextNew as="p" size="s" weight="regular" --rk-text-color="var(--rk-text-low)">
      {subtitle}
    </TextNew>
  </div>
  <div class="cta">
    <slot name="cta" />
  </div>
</div>

<style>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .padding-bottom {
    padding-bottom: 10%;
  }
  .cta {
    display: flex;
    gap: 8px;
  }
  .msg {
    text-align: center;
    margin-top: 12px;
    margin-bottom: 32px;
  }
</style>
